/**
 * Which store, if any, a visitor's browser should be offered.
 *
 * This module holds no store URL. The App Store and Play Store links are a
 * global admin fact, served by POST /site/v1/public/app-availability/get and
 * read through `useAppAvailabilityGet` from `@sportsmet/site-sdk/public`
 * (ISSUE-095). A caller passes that response payload in.
 *
 * When a platform has no link set, which is the launch state for both, this
 * returns null and the caller renders nothing at all for that platform. Not a
 * disabled button, not a placeholder.
 *
 * Consumers: `apps/app/src/features/pools/GetTheAppBanner.tsx`.
 * `apps/app/src/routes/sign-in_.link.tsx` reads the same hook directly.
 */

export type typeStorePlatform = "ios" | "android" | null;

export function storePlatformFromUserAgent(
  userAgent: string,
): typeStorePlatform {
  const lowered = userAgent.toLowerCase();
  if (
    lowered.includes("iphone") ||
    lowered.includes("ipad") ||
    lowered.includes("ipod")
  ) {
    return "ios";
  }
  if (lowered.includes("android")) return "android";
  return null;
}

export type typeStoreAvailability = {
  iosStoreUrl?: string | undefined;
  androidStoreUrl?: string | undefined;
};

export function storeUrlFor(
  platform: typeStorePlatform,
  availability: typeStoreAvailability | null | undefined,
): string | null {
  if (platform === null) return null;
  const value =
    platform === "ios"
      ? availability?.iosStoreUrl
      : availability?.androidStoreUrl;
  return typeof value === "string" && value !== "" ? value : null;
}
